import { render, staticRenderFns } from "./tickets.vue?vue&type=template&id=779c2114&scoped=true&"
import script from "./tickets.vue?vue&type=script&lang=js&"
export * from "./tickets.vue?vue&type=script&lang=js&"
import style0 from "./tickets.vue?vue&type=style&index=0&id=779c2114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779c2114",
  null
  
)

export default component.exports